import { Controller } from "@hotwired/stimulus"

const LOCKED_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V7a4.5 4.5 0 10-9 0v3.5m-.75 0h10.5A1.75 1.75 0 0118.5 12.25v7A1.75 1.75 0 0116.75 21H7.25A1.75 1.75 0 015.5 19.25v-7a1.75 1.75 0 011.75-1.75z" /></svg>`

const UNLOCKED_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5V7A4.5 4.5 0 009 2.5 4.48 4.48 0 006.2 3.7M5.5 10.5h10.5A1.75 1.75 0 0117.75 12.25v7A1.75 1.75 0 0116 21H7.25A1.75 1.75 0 015.5 19.25v-7a1.75 1.75 0 011.75-1.75z" /></svg>`

// Toggles definition edit mode and asks whether to publish a new catalog set on save.
export default class extends Controller {
  static targets = ["lockButton", "lockIcon", "readonly", "form", "publishField", "saveButton"]
  static values = { unlocked: { type: Boolean, default: false } }

  connect() {
    this.#sync()
  }

  unlockedValueChanged() {
    this.#sync()
  }

  toggle() {
    this.unlockedValue = !this.unlockedValue
  }

  confirmPublish(event) {
    if (!this.hasPublishFieldTarget) return

    const publish = window.confirm(
      "Publish a new catalog set with this errata?\n\nOK = publish new set\nCancel = save as draft only"
    )
    this.publishFieldTarget.value = publish ? "true" : "false"
  }

  #sync() {
    const unlocked = this.unlockedValue

    if (this.hasReadonlyTarget) {
      this.readonlyTarget.classList.toggle("hidden", unlocked)
    }
    if (this.hasFormTarget) {
      this.formTarget.classList.toggle("hidden", !unlocked)
    }
    if (this.hasLockButtonTarget) {
      this.lockButtonTarget.setAttribute("aria-pressed", unlocked ? "true" : "false")
      const label = unlocked ? "Lock" : "Unlock to edit"
      this.lockButtonTarget.setAttribute("aria-label", label)
      this.lockButtonTarget.setAttribute("title", label)
    }
    if (this.hasLockIconTarget) {
      this.lockIconTarget.innerHTML = unlocked ? UNLOCKED_ICON : LOCKED_ICON
    }
  }
}
